// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"822a69e4","526":"28a2cf75","707":"fc86457b","918":"b03e2284"}[chunkId] + ".js";
};